import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { DialogHelper } from "../../core/util/dialogHelper";
import ServiceHoursPos, { ServiceHoursPosProps } from "./serviceHoursPos";
import { ServiceHoursEntity, ServiceHoursPosEntity } from "./serviceHours";
import { Metadata } from "../../core/components/commonApp";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export default class ServiceHoursPosGrid extends React.Component<ServiceHoursPosGridProps, ServiceHoursPosGridState> {
    private _gridOptions: kendo.ui.GridOptions = null;
    _translations: {};
    private updateTypeOfStr(pos: ServiceHoursPosEntity, typesOfDay: KeyValuePair<number, string>[]) {
        let typeOfDay: string;
        var tod = Helper.getArrayItem(typesOfDay, "Key", pos.TypeOfDay);
        if (tod != null)
            typeOfDay = tod.Value;
        else
            typeOfDay = this._translations["WebSMS.SLA.UnknownValue"]+ pos.TypeOfDay;
        pos.TypeOfDayStr = typeOfDay;
    }

    constructor(props: ServiceHoursPosGridProps) {
        super(props);

        this._translations = this.props.context.translations;
        for (let pos of props.entity.Positions) {
            this.updateTypeOfStr(pos, props.context.TypesOfDay);
            pos.StartStr = Helper.dates.fromMinutesSinceMidnight(pos.StartMinute);
            pos.EndStr = Helper.dates.fromMinutesSinceMidnight(pos.EndMinute);
        }
        this._gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: false,
            scrollable: true,
            columns: [
                {
                    field: "TypeOfDayStr",
                    title: this._translations["WebSMS.SLA.TypeOfDay"],
                    width: 95
                },
                {
                    field: "StartStr",
                    title: Config.translations.from,
                    width: 65
                },
                {
                    field: "EndStr",
                    title: Config.translations.to,
                    width: 65
                }
            ]
        }
        this.state = {
            gridData: props.entity.Positions,
            writable: props.entity.RecordRight.CanWrite,
            enableCopyButton: true
        };
    }



    private _openPos = (dataItem: ServiceHoursPosEntity = null) => {
        Helper.getMetaData("editServiceHoursPos")
            .then(result => {
                const entity = dataItem;
                const metadata = result;
                this._initCodeWindow(entity, metadata);
            });
    }

    private _initCodeWindow = (entity: any, metaData: any) => {
        const entityCopy = JSON.parse(JSON.stringify(entity));
        const props: ServiceHoursPosProps = {
            dataSources: {}, metadata: metaData as Metadata, entity: entityCopy, isWindow: true, context: {}, title: "",
            typesOfDay: this.props.context.TypesOfDay
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, (target) => {
            // this._getGridData();
        });
        sheet.bind(SheetEventType.SavedSuccessfully,
            (position: ServiceHoursPosEntity) => {
                var item = Helper.getArrayItem(this.props.entity.Positions, "Id", position.Id);
                if (item == null) {
                    item = JSON.parse(JSON.stringify(position));
                    this.props.entity.Positions.push(item);
                } else {
                    item.TypeOfDay = position.TypeOfDay;
                    item.StartMinute = position.StartMinute;
                    item.StartStr = position.StartStr;
                    item.EndMinute = position.EndMinute;
                    item.EndStr = position.EndStr;
                }
                // die Positionen müssen immer nach TypeOfDay, StartMinute sortiert sein.
                //   die Sortierung muss auch nach dem Edit vorgenommen werden (da der TypeOfDay bzw. StartMinute sich geändert haben könnte)
                this.props.entity.Positions.sort((a, b) => { return a.TypeOfDay == b.TypeOfDay ? a.StartMinute - b.StartMinute : a.TypeOfDay - b.TypeOfDay });
                this.updateTypeOfStr(item, this.props.context.TypesOfDay);
                this.props.onChange(this.props.field, item.Id);
            });

        sheet.show(() => {
            sheet.mountContent(ServiceHoursPos, props);
        });
    }


    private _deletePos = (id: string) => {

        DialogHelper.confirm(Config.translations.delete).then(isOk => {
            if (isOk) {
                let item = Helper.findObjIndex(this.props.entity.Positions, "Id", id);
                if (item >= 0) {
                    this.props.entity.Positions.splice(item, 1);
                    this.props.onChange(this.props.field, id);
                }
            }
        });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: ServiceHoursPosEntity) => {
        if (type == ToolBarStandardButtonType.NEW) {
            let entity: ServiceHoursPosEntity = Helper.createEmptyEntity() as ServiceHoursPosEntity;
            entity.Id = kendo.guid();
            this._openPos(entity);
        }
        else if (type == ToolBarStandardButtonType.EDIT) {
            this._openPos(dataItem);
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this._deletePos(dataItem.Id);
        }
    }

    private _handleCustomButton = (id: string, dataItem: ServiceHoursPosEntity) => {
        if (id === "copy") {
            if (this.state.gridData.filter(f => f.TypeOfDay === (dataItem.TypeOfDay + 1)).length > 0) {
                const text = this._translations["WebSMS.SLA.ServiceHourPosCopy"];
                DialogHelper.confirm(text).then(isOk => {
                    if (isOk) {
                        this._copyPos(dataItem);
                    }
                });
            } else {
                this._copyPos(dataItem);
            }
        }
    }

    private _copyPos = (dataItem: ServiceHoursPosEntity) => {
        let item = Helper.createEmptyEntity() as ServiceHoursPosEntity;
        item.StartMinute = dataItem.StartMinute;
        item.StartStr = dataItem.StartStr;
        item.EndMinute = dataItem.EndMinute;
        item.EndStr = dataItem.EndStr;
        item.TypeOfDay = dataItem.TypeOfDay + 1;
        item.IsNew = true;
        item.Id = kendo.guid();
        this.updateTypeOfStr(item, this.props.context.TypesOfDay);
        this.props.entity.Positions.push(item);
        this.props.entity.Positions.sort((a, b) => { return a.TypeOfDay == b.TypeOfDay ? a.StartMinute - b.StartMinute : a.TypeOfDay - b.TypeOfDay });
        this.props.onChange(this.props.field, item.Id);
    }


    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this.state.writable });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.state.writable });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.writable });

        const customButtom: Array<GridCustomToolBarButton> = [];
        customButtom.push({ autoEnabledOnRecordSelected: true, caption: this._translations["Standard.Kopieren"], enabled: this.state.enableCopyButton && this.state.writable, id: "copy", iconClass: "k-i-redo" });

        let grid = (
            <Grid data={this.state.gridData} options={this._gridOptions} id="serviceHoursPosGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} customButtons={customButtom}
                onClickCustomButton={this._handleCustomButton} onSelectionChanged={this._onSelectionChanged}
            />
        );
        return (grid)
    }

    private _onSelectionChanged = (dataItem: ServiceHoursPosEntity) => {
        let oldState = this.state.enableCopyButton;
        let newState = false;
        if (Helper.hasValue(dataItem)) {
            newState = (dataItem.TypeOfDay < 8);
        }

        if (oldState !== newState) {
            //this.setState({ enableCopyButton: newState });
        }


    }


    componentDidMount() {
        //this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>
                    {grid}
                </div>
            </div>);

    }
};

interface ServiceHoursPosGridProps {
    context: { TypesOfDay: KeyValuePair<number, string>[], translations: StringKeyDictionary<string> };
    translations: StringKeyDictionary<string>;
    field: any;
    entity: ServiceHoursEntity;
    onChange: (field, value) => void
}

interface ServiceHoursPosGridState {
    gridData: ServiceHoursPosEntity[];
    enableCopyButton: boolean;
    writable: boolean;
}